import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client';
import { AgxButton, AgxSpacer } from '@urbanx/agx.ui-components2';

interface ContractFormButtonsProps {
  beginSubmission: () => Promise<void>;
  beginContract: () => Promise<void>;
  beginContractExchange: () => Promise<void>;
  campaignState: CampaignDetailModelState;
  areVendorsValid: boolean;
  disableButtons: boolean;
  isArchived: boolean;
  blankContractIsLive: boolean;
}

const ContractFormButtons = ({
  beginSubmission,
  beginContract,
  beginContractExchange,
  campaignState,
  areVendorsValid,
  disableButtons,
  isArchived,
  blankContractIsLive,
}: ContractFormButtonsProps) => {
  switch (campaignState) {
    case CampaignDetailModelState.NSW:
      return (
        <AgxSpacer direction="vertical" gap="xs" contentAlignment="center" fill>
          <AgxButton
            id="agx-begin-contract"
            dataTestId="agx-begin-contract"
            variant="primary"
            size="large"
            stretch
            text="Solicitor Exchange"
            onClick={beginContract}
            disabled={!areVendorsValid || disableButtons || isArchived}
          />
          <AgxButton
            id="agx-contract-exchange"
            variant="hollow"
            size="large"
            stretch
            text="Agent Exchange"
            onClick={beginContractExchange}
            disabled={!blankContractIsLive || !areVendorsValid || disableButtons || isArchived}
          />
          <AgxButton
            id="agx-submit-contract"
            dataTestId="agx-submit-contract"
            variant="hollow"
            size="large"
            stretch
            text="Submit Contract"
            onClick={beginSubmission}
            disabled={!areVendorsValid || disableButtons || isArchived}
          />
        </AgxSpacer>
      );
    case CampaignDetailModelState.QLD:
    default:
      return (
        <AgxSpacer direction="vertical" gap="xs" contentAlignment="center" fill>
          <AgxButton
            id="agx-begin-contract"
            dataTestId="agx-begin-contract"
            variant="primary"
            size="large"
            stretch
            text="New Contract"
            onClick={beginContract}
            disabled={!blankContractIsLive || disableButtons || isArchived}
          />
          <AgxButton
            id="agx-submit-contract"
            dataTestId="agx-submit-contract"
            variant="hollow"
            size="large"
            stretch
            text="Submit Contract"
            onClick={beginSubmission}
            disabled={disableButtons || isArchived}
          />
        </AgxSpacer>
      );
  }
};

export default ContractFormButtons;
